import { render, staticRenderFns } from "./NoSubCategory.vue?vue&type=template&id=3139f445&scoped=true&"
import script from "./NoSubCategory.vue?vue&type=script&lang=ts&"
export * from "./NoSubCategory.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=3139f445&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3139f445",
  null
  
)

export default component.exports